import {Module} from "../index";
import RandomLineupper from "@/modules/ai/services/lineupper/RandomLineupper";
import BestMatchingLineupper from "@/modules/ai/services/lineupper/BestMatchingLineupper";
import AIServiceProvider from "@/modules/ai/services/AIServiceProvider";
import LineupEventSubscriber from "@/modules/ai/subscribers/LineupEventSubscriber";
import {BaseModule} from "@/modules/base";
import RandomTransferDecider from "@/modules/ai/services/transferDecider/RandomTransferDecider";
import TeamLevelTransferDecider from "./services/transferDecider/CurrentSkillTransferDecider";

export class AIModule extends Module {
  dependsOn = [
    BaseModule,
  ];

  public entities = [];

  eventSubscribers = [
    LineupEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<AIServiceProvider>(AIServiceProvider).to(AIServiceProvider);
    this.app.bind<RandomLineupper>(RandomLineupper).to(RandomLineupper);
    this.app.bind<BestMatchingLineupper>(BestMatchingLineupper).to(BestMatchingLineupper);
    this.app.bind<RandomTransferDecider>(RandomTransferDecider).to(RandomTransferDecider);
    this.app.bind<TeamLevelTransferDecider>(TeamLevelTransferDecider).to(TeamLevelTransferDecider);
  }

  boot() {
    super.boot();
  }
}
